import { withTheme } from "styled-components";
import ThemePartialProvider from "./components/ThemePartialProvider.js";
export default withTheme(ThemePartialProvider);
